export default {
  title: 'Control acces: {{role}}',
  form: {
    companies: {
      label: 'Vizibil pentru toți membrii cu rolul {{role}}',
      tooltip: 'Acesta va fi adăugat la locațiile unde membrul echipei s-a înregistrat',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor, vă rugăm reîmprospătați pagina',
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
